import PG from "../ta_pg";

export const executeOnUpgradeIgnored = () => {
  if ($(".modal-upgradeAgent").find("#noShowCheckbox").is(":checked")) {
    PG.localConfig.declineUpgrade = PG.state.currentVersion;
    $.cookie("filecatalystLocalConfig", JSON.stringify(PG.localConfig));
  }
};
